import PercentileChip from "../PercentileChip";
import { HeadshotEntry } from "./utils";
import { formatSigned } from "../../util/formatSigned";

const headshotUrl = (playerId: number) =>
  `https://cdn.nba.com/headshots/nba/latest/1040x760/${playerId}.png`;

/**
 * Six headshots, each over its value on the report's percentile chip — who
 * beat or missed the model's expectation. No greyscale `filter` (CONVENTIONS:
 * no filter effects on repeated print elements); the chip carries the read.
 */
export default function HeadshotStrip({
  title,
  hint,
  players,
}: {
  title: string;
  /** What the values measure, on hover (web only; print shows the title). */
  hint?: string;
  players: HeadshotEntry[];
}) {
  return (
    <div className="hs">
      <div className="subh" title={hint}>
        {title}
      </div>
      <div className="hsrow">
        {players.map((p) => (
          <div className="hsp" key={p.playerId}>
            {/* alt="": the name prints under the photo; a failed image must not
                spill its alt text across the strip */}
            <img src={headshotUrl(p.playerId)} alt="" />
            <PercentileChip
              value={formatSigned(p.value, 1)}
              percentile={p.percentile}
              fontSize="0.78rem"
              minWidth={36}
            />
            <span className="hsn">{p.playerName.split(" ").slice(1).join(" ") || p.playerName}</span>
          </div>
        ))}
      </div>
    </div>
  );
}
